import { createFileRoute } from "@tanstack/react-router";
import DEUmweltzone from "@/pages/landing/DEUmweltzone";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/umweltzone-fahrzeuge/")({
  head: () => routeHead("/de/umweltzone-fahrzeuge/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <DEUmweltzone />
  );
}
